/**
 * Checks if a value is a plain object (not an array, null, or other type)
 * @param {unknown} item - The value to check
 * @returns {boolean} True if the value is a plain object
 */
const isObject = (item: unknown): item is Record<string, unknown> =>
  item !== null && typeof item === 'object' && !Array.isArray(item);

/**
 * Deep merges two objects, recursively merging nested objects.
 * Arrays are replaced, not merged. Functions are copied by reference.
 * @param {any} target - The target object to merge into
 * @param {any} source - The source object to merge from
 * @returns {any} The merged object
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deepMerge = (target: any, source: any): any => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const output = { ...target };

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach((key) => {
      const sourceValue = source[key];
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
      const targetValue = output[key];

      if (isObject(sourceValue) && isObject(targetValue)) {
        // Recursively merge nested objects
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
        output[key] = deepMerge(targetValue, sourceValue);
      } else {
        // Replace value (including arrays)
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        output[key] = sourceValue;
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  return output;
};
